var SET_NAME_METHOD = 'setName';
var SET_DESCRIPTION_METHOD = 'setDescription';
var SET_VISIBLE_METHOD = 'setVisible';
var SET_READ_ONLY_METHOD = 'setReadOnly';
var SET_VALUE_METHOD = 'setValue';
var SET_REQUIRED_METHOD = 'setRequired';
var SET_OPTIONS_VISIBILITY_METHOD = 'setOptionsVisibility';
export var propertyToMethodMap = {
  fieldName: SET_NAME_METHOD,
  description: SET_DESCRIPTION_METHOD,
  isVisible: SET_VISIBLE_METHOD,
  isReadOnly: SET_READ_ONLY_METHOD,
  value: SET_VALUE_METHOD,
  isRequired: SET_REQUIRED_METHOD,
  optionsVisibility: SET_OPTIONS_VISIBILITY_METHOD
};
export var mapFieldPropertyToApiMethod = function mapFieldPropertyToApiMethod(fieldProperty) {
  var method = propertyToMethodMap[fieldProperty];
  if (!method) {
    throw new Error("No method found for field property: ".concat(fieldProperty));
  }
  return method;
};